module.exports = "/images/bannerTwo.jpg";